"use client";
import { classNames } from "@lib/helpers";
import { debounce } from "lodash";
import { useEffect, useState } from "react";

const items = [
  { name: "Details", href: "#job-details", id: "job-details" },
  { name: "Description", href: "#description", id: "description" },
  { name: "Benefits", href: "#benefits", id: "benefits" },
  { name: "Similar jobs", href: "#similar-jobs", id: "similar-jobs" },
];

export default function JobNav() {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = debounce(() => {
      let closestSection = "";
      let minDistance = Number.MAX_VALUE;

      items.forEach((item) => {
        const section = document.getElementById(item.id);
        if (section) {
          const rect = section.getBoundingClientRect();
          const distanceFromTop = Math.abs(rect.top - 200);

          if (distanceFromTop < minDistance) {
            minDistance = distanceFromTop;
            closestSection = item.id;
          }
        }
      });

      setActiveSection(closestSection);
    }, 50);

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run once to set the correct active section on page load

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="md:w-12 md:sticky top-32 mb-5 md:mb-0">
      <ul className="flex flex-row md:flex-col">
        {items.map((item, index) => (
          <li key={item.name} className="flex flex-col flex-1">
            <a
              href={item.href}
              className={classNames(
                `job-details-nav-link block md:w-full md:flex py-4 mb-0.5 items-center justify-center text-center text-[13px] md:text-sm font-medium bg-gray-100 hover:bg-primary hover:text-white transition`,
                activeSection === item.id ? "bg-primary text-white" : "",
                index === 0 ? "md:rounded-bl-md" : "",
                index === items.length - 1 ? "md:rounded-tl-md" : ""
              )}
            >
              <span>{item.name}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
